import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyInquiryOrder from './index.vue';

var CopyInquiryOrderPage = function (_super) {
  __extends(CopyInquiryOrderPage, _super);

  function CopyInquiryOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopyInquiryOrderPage = __decorate([Component({
    components: {
      AddEditCopyInquiryOrder: AddEditCopyInquiryOrder
    }
  })], CopyInquiryOrderPage);
  return CopyInquiryOrderPage;
}(Vue);

export default CopyInquiryOrderPage;